import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IMemberSearchCriteria, IMemberSearchResult, IMemberSearchResultV2 } from './member-search.model';

export const searchMembers = createAction(
  '[Member Lookup] Search Members',
  props<{ memberSearchCriteria: IMemberSearchCriteria }>()
);

export const searchMembersSuccess = createAction(
  '[Member Lookup] Search Members Success',
  props<{ memberSearchResults: IMemberSearchResult[] }>()
);

export const searchMembersFailure = createAction(
  '[Member Lookup] Search Members Failure',
  props<{ error: HttpErrorResponse }>()
);

export const searchMembersV2 = createAction(
  '[Member Lookup] Search Members V2',
  props<{ memberSearchCriteria: IMemberSearchCriteria }>()
);

export const searchMembersV2Success = createAction(
  '[Member Lookup] Search Members V2 Success',
  props<{ memberSearchResults: IMemberSearchResultV2[] }>()
);

export const searchMembersV2Failure = createAction(
  '[Member Lookup] Search Members V2 Failure',
  props<{ error: HttpErrorResponse }>()
);

export const resetSearchMembers = createAction(
  '[Member Lookup] Reset Members'
);

export const setPagePosition = createAction(
  '[Member Lookup] Set Page Position',
  props<{ pagePosition: number }>()
);

export const setCurrentResultsPage = createAction(
  '[Member Lookup] Set Current Results Page',
  props<{ pageNumber: number, sort: { col: string; dir: number } }>()
);

export const setCurrentSort = createAction(
  '[Member Lookup] Set Current Results Sort',
  props<{ sort: { col: string; dir: number; } }>()
);

export const setPageSize = createAction(
  '[Member Lookup] Set Page Size',
  props<{ pageSize: number }>()
);

export const resetSearchCriteria = createAction(
  '[Member Lookup] Reset Search Criteria'
);
